

import React from "react";
import classes from "./Loader.module.css";


const Loader = () => {

    return (
        <div className={classes.BackDrop}>
            <div className={classes.Loader}></div>
        </div>
    )
}

export default Loader